import { useState } from "react";
import {
  Box,
  Typography,
  Dialog,
  Stack
} from "@mui/material";
import closeIcon from "../../assets/icon-close.svg";
import appstore from "../../assets/app-store.svg";
import googleplay from "../../assets/gpay.svg";
import { BannerNotificationContent } from "../contents";
import "../../Layout/mobileAppDownloadLinks.css";

type Props = {
  isOpen: boolean;
  close: () => void;
};

const AppDownlaodDialog = ({ isOpen, close }: Props) => {
  
  const bannerNotificationContent: any = BannerNotificationContent();
  const Contentlink = bannerNotificationContent?.entry?.Download_Banner;

  return (
    <Box>
      <Dialog
        open={isOpen}
        onClose={close}
        aria-labelledby="scroll-dialog-title"
      >
        <Stack className="appDownloadDialogBox">
          <Box className="appDown-body-container">
            <Typography className="appDownloadLinksTitle" component="h2" id="scroll-dialog-title">
              {Contentlink?.for_desktop_modal_title}
            </Typography>

            <Typography className="appDownloadLinksDiscription">
              {Contentlink?.for_desktop_modal_discription}
            </Typography>

            <Stack direction="row" className="app-down-container">
              <a
                href="https://apps.apple.com/us/app/brightspeed-wifi/id1658477411"
                target="_blank"
                className="app-download-anchorAppStore"
              >
                <Stack
                  direction="row"
                  className="app-download-anchor-container"
                >
                  <img
                    src={appstore}
                    alt="Download the BrightSpeed app with Apple Store"
                    className="app-download-anchor-img"
                  />

                </Stack>
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.brightspeed.smarthome"
                target="_blank"
                className="app-download-anchor"
              >
                <Stack
                  direction="row"
                  className="app-download-anchor-container"
                >
                  <img
                    src={googleplay}
                    alt="Download the BrightSpeed app with Google Play"
                    className="app-download-anchor-img"
                  />

                </Stack>
              </a>
            </Stack>
            <Stack
              direction="row"
              alignItems="center"
              className="app-download-do-no-see-container"
            >
              <Typography component="span" className="checkBox">
                <label className="checkboxMain">
                  {Contentlink?.for_desktop_modal_do_not_see_msg}
                  <input
                    type="checkbox"
                    className="radioInput"
                    // onClick={close}
                  />
                  <span className="checkBoxLabel"></span>
                </label>
              </Typography>
            </Stack>
          </Box>
          <Stack
            direction="row"
            justifyContent="end"
            className="close-icon-cantainer"
          >
            <button className="modelButton" aria-label="Close the dialog"
              onClick={close}
              >
              <img
                src={closeIcon}
                alt="Close the dialog"
                className="cursor-pointer"
              /></button>
          </Stack>
        </Stack>
      </Dialog>
    </Box>
  );
};

export default AppDownlaodDialog;